import React from 'react';
import { motion } from 'framer-motion';

const positions = [
  {
    title: 'Front-End Developer',
    location: 'Bangalore, India/Remote',
    level: 'Mid-Level',
    type: 'Internship',
  },
  {
    title: 'AI Engineer',
    location: 'Bangalore, India/Remote',
    level: 'Mid-Level',
    type: 'Internship',
  },
  {
    title: 'Marketing',
    location: 'Hybrid',
    level: 'Junior',
    type: 'Internship',
  },
  {
    title: 'HR Intern',
    location: 'Hybrid',
    level: 'Junior',
    type: 'Internship',
  },
];

const OpenPositions = () => {
  return (
    <section id="open-positions" className="py-24 px-6 bg-gradient-to-b from-[#24243e] to-[#0B0C1C] text-white">
      <h2 className="text-4xl sm:text-5xl font-bold text-center mb-16 bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
        Current Openings
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
        {positions.map((job, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-white/5 backdrop-blur-lg rounded-xl p-6 space-y-3 border border-white/10 hover:border-cyan-400 transition shadow-lg"
          >
            <h3 className="text-xl font-bold">{job.title}</h3>
            <p className="text-sm text-white/70">{job.level} • {job.type}</p>
            <p className="text-sm text-white/70">{job.location}</p>
            <button
              onClick={() => document.getElementById('careers')?.scrollIntoView({ behavior: 'smooth' })}
              className="mt-4 inline-block px-4 py-2 bg-gradient-to-r from-purple-500 to-cyan-400 rounded-full text-sm hover:scale-105 transition"
            >
              Apply Now
            </button>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default OpenPositions;
